import React from "react";

import { Icon } from "semantic-ui-react";

import CheckInLayout from "./CheckInLayout";

import "./SearchingMonitor.css";

const SearchingMonitor = () => {
  return (
    <CheckInLayout>
      <div className="searching-content">
        <div className="searching-center">
          <div className="searching-icon-container">
            <div className="searching-spinner" />
            <Icon name="search" className="searching-icon" />
          </div>
          <div style={{ fontWeight: 700, fontSize: "2.5rem", color: "#1a1a1a" }}>
            กำลังค้นหาข้อมูลผู้รับบริการ
          </div>
          <div style={{ fontSize: "1.5rem", color: "#999999" }}>กรุณารอสักครู่...</div>
        </div>
      </div>
    </CheckInLayout>
  );
};

SearchingMonitor.displayName = "SearchingMonitor";

export default SearchingMonitor;
